module.exports = __webpack_public_path__ + "static/media/institution.ed515b4b.svg";